"use client";
import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { useLocaleText as p, Box as u, Group as s, Heading as _, TextLink as g, Grid as d, sharedHandler as w } from "@ingeniorforeningen/figurine-core";
import { forwardRef as y, memo as N } from "react";
import '../../../assets/Section.css';const S = "_head_wex8a_2", j = "_header_wex8a_8", H = "_content_wex8a_16", a = {
  head: S,
  header: j,
  content: H
}, o = y((h, l) => {
  const { header: n, id: m, link: t, children: r, centerHeader: c, ...x } = h, f = p();
  return /* @__PURE__ */ i(u, { ...x, children: [
    (n || t) && /* @__PURE__ */ e(s, { className: a.head, mb: r ? "md" : void 0, ref: l, grow: !0, children: n && /* @__PURE__ */ i(s, { spacing: 0, justify: "space-between", children: [
      /* @__PURE__ */ e(
        _,
        {
          text: n,
          className: a.header,
          align: c ? "center" : void 0,
          generateAnchor: !0,
          type: "h2",
          id: m,
          mod: { "with-center-header": c }
        }
      ),
      t && /* @__PURE__ */ e(
        g,
        {
          variant: "component",
          icon: "ChevronRight",
          iconPlacement: "right",
          text: t.text || f.seeMore,
          href: t.href,
          target: "_self"
        }
      )
    ] }) }),
    r && /* @__PURE__ */ e(d, { container: !0, className: a.content, children: /* @__PURE__ */ e(d, { item: !0, children: r }) })
  ] });
});
o.displayName = "Section";
const b = w(N(o));
b.displayName = o.displayName;
export {
  a as S,
  o as _Section,
  b as default
};
